// List is prioritized for friends list
// NOTE: order matters, represents the hierarchy of statuses
export enum PresenceType {
    ONLINE = 'Online',
    AWAY = 'Away',
    OFFLINE = 'Offline'
}

export default PresenceType;
